import React, { useRef, useState } from "react";

import PageHeader from "../../../../molecules/PatientDetailsV2/PageHeader/PageHeader";
import DietPlansList from "../../../../molecules/DietV2/DietPlansList/DietPlansList";
import BottomSheet from "../../../../atoms/BottomSheet/BottomSheet";
import CreateDietPlan from "../../../../molecules/DietV2/CreateDietPlan/CreateDietPlan";
import useCoachPermissions from "../../../../hooks/useCoachPermissions";
import Button from "../../../../atoms/Button/Button";

import { ReloadOutlined } from "@ant-design/icons";

const DietTaskPage: React.FC<any> = () => {
  // Every coach reads the plans; only the diet coach (or a chief) creates one.
  const { canManageDiet } = useCoachPermissions();
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const [editDietPlan, setEditDietPlan] = useState<any>(null);
  const [copyDietPlan, setCopyDietPlan] = useState<any>(null);

  const dietPlansListRef = useRef<any>(null);

  const handleAddDietClick = () => {
    setShowBottomSheet(true);
  };

  const handleEditDietClick = (dietPlan: any) => {
    setShowBottomSheet(true);
    setEditDietPlan(dietPlan);
  };

  const handleCopyDietClick = (dietPlan: any) => {
    setShowBottomSheet(true);
    setCopyDietPlan(dietPlan);
  };

  const onSuccess = () => {
    setShowBottomSheet(false);
    setEditDietPlan(null);
    setCopyDietPlan(null);
    window.scrollTo(0, 0);
    dietPlansListRef?.current?.refresh();
  };

  return (
    <div className="diet-plan-page-container">
      <PageHeader
        title="List of Diet Plans"
        actions={
          <>
            <Button
              variant="outlined"
              title="Refresh"
              iconStart={<ReloadOutlined />}
              onClick={() => dietPlansListRef?.current?.refresh()}
            />
            {canManageDiet && (
              <Button onClick={handleAddDietClick}>+ Create Diet Plan</Button>
            )}
          </>
        }
      />

      <DietPlansList
        ref={dietPlansListRef}
        handleAddDietClick={handleAddDietClick}
        handleEditDietClick={handleEditDietClick}
        handleCopyDietClick={handleCopyDietClick}
      />

      {showBottomSheet && (
        <BottomSheet
          isOpen={showBottomSheet}
          title="Create Diet Plan"
          onClose={() => setShowBottomSheet(false)}
        >
          <CreateDietPlan
            onCancel={() => {
              setShowBottomSheet(false);
              setEditDietPlan(null);
            }}
            onSuccess={onSuccess}
            selectedDietPlan={editDietPlan || copyDietPlan}
            isEdit={!!editDietPlan}
            isCopy={!!copyDietPlan}
          />
        </BottomSheet>
      )}
    </div>
  );
};

export default DietTaskPage;
